<template>
    <div class="ProjectRevisionHistoryComponent DataTables">

        <div v-show="isData" :id="id"></div>

        <LoaderComponent v-if="!isData"></LoaderComponent>

    </div>
</template>
<script>
import LoaderComponent from "@/components/shared/LoaderComponent"
import * as Tools from './../../Tools/Tools'
import { mapGetters } from 'vuex'
import $ from 'jquery';
import dt from 'datatables.net-bs4';

export default {
    name: "ProjectRevisionHistoryComponent",
    props: {

      lang: Object
    },
    components: {
       LoaderComponent
    },
    data() {
      return {
        name: "ProjectRevisionHistoryComponent",
        mainTable: "",
        id: "ProjectRevisionHistoryComponent",
        showAll: false
      }
    },
    computed: {
        ...mapGetters({
            currentUser: 'currentUser',
            routingData: 'routingData'
        }),
        selectedRevisionRow(){
            return this.$store.getters.selectedRevisionRow
        },
        dataTable() {



            //data.sort(function (a, b) { return b.revision - a.revision });

            return this.$store.getters.revisionHistory;
        },
        lastRevisionHistory(){
            if (this.$store.getters.revisionHistory == null){
                return
            }
            let tab = this.$store.getters.revisionHistory;
            let obj = tab[0];
            for (let i = 0, lei = tab.length; i < lei; i++){

                if (tab[i].revision > obj.revision){
                obj = tab[i];
                }
            }

            return obj;
            },
        isOwner(){
            if (this.lastRevisionHistory == undefined){
                return false;
            }


            if (this.lastRevisionHistory.userId == this.$store.getters.currentUser.userId && this.lastRevisionHistory.status.display == "pending"){
                return true;
            }
            return false;
        },
        isData() {

            return Object.keys(this.dataTable).length != 0

        },
        elementId() {

            return this.$route.query.id;
        },
        reloadedAfterActionComplex() {
            return this.$store.getters.reloadedAfterActionComplex;
        },
    },
    created() {
        this.reloadData();


    },
    watch: {
        elementId: function () {

            this.reloadData();

        },
        dataTable: {
            handler: function (newVal) {

                if (newVal.length == 0) {
                    let component = "DataTableFilteredOnApiProjComponent";

                    const reloadObj = {
                        status: true,
                        name: component
                    }
                    this.$store.dispatch("reloadAfterActionComplex", reloadObj);

                    let to = "/ProjectManager/ProjectTable";


                    const query = {
                        from: this.$route.path,
                        to: to,

                    }

                    this.$router.push({ path: to, query: query });
                } else {

                    if (newVal.length > 0) {
                        let revisionId = newVal[newVal.length - 1].id;

                        this.$router.push({ query: { ...this.$route.query, revisionId: revisionId } });

                    }

                    this.buildTable();
                }
            },
            deep: true


        },

        reloadedAfterActionComplex: {
            handler: function (newValue) {

                for (let el in newValue) {
                    if (newValue[el].name == this.name) {
                        if (newValue[el].status == true) {

                            this.reloadData();

                            newValue[el].status = false;

                            this.$store.dispatch("reloadAfterActionComplex", newValue[el]);
                        }
                    }
                }
            },
            deep: true

        },

    },
    beforeDestroy() {

      if (this.dtFilter) {
        const idx = $.fn.dataTable.ext.search.indexOf(this.dtFilter);
        if (idx > -1) {
          $.fn.dataTable.ext.search.splice(idx, 1);
        }
      }

      if (this.mainTable) {
        this.mainTable.destroy();

      }
    },
    methods: {
      reloadData() {

          let vue = this;

          let value = this.elementId;

          this.$store.dispatch(this.$store.getters.sectionPrefix + '_getRevisionHistoryExtended', value)
          .then((result) => {
              console.log(result)
              if (result.status == "OK") {

                  if (result.data.length > 0) {
                      let revisionId = result.data[result.data.length - 1].id;

                      vue.$router.push({ query: { ...vue.$route.query, revisionId: revisionId } });
                  }

              }

          })


      },
      updateIsArchive(obj) {

          for (let i = 0, lei = this.dataTable.length; i < lei; i++){

              if (this.dataTable[i].id == obj.projectRevisionId) {

                  this.dataTable[i].isArchive = obj.isArchive;
              }
          }

      },
      format(d) {

        let isArchive = d.isArchive;
        let checked = "";
        if (isArchive == null) {
            isArchive = false;
            checked = "";
        }
        if (isArchive == true) {
            isArchive = true;
            checked = "checked=\"checked\"";
        }
        if (isArchive == false) {
            isArchive = false;
            checked = "";
        }



        let disabled = "disabled=\"disabled\"";
        if (this.isOwner == true || this.currentUser.role == "Admin") {
            disabled = "";
        }



        let checkbox = '<input ' + disabled + ' type="checkbox" ' + checked + ' class="custom-control checkbox_archive btn-primary" id="isArchived___' + d.id + '" value="'+isArchive+'">';


        let projectProperties = "";

        const properties = Object.fromEntries(
          Object.entries(d)
          .filter(([key]) => key.startsWith("p___"))
          .map(([key, value]) => [key.slice(4), value])
        );



        for (const [key, value] of Object.entries(properties)) {

          let prop = $.fn.dataTable.render.text().display(value);
          if (prop == null) {
              prop = "";
          }


          let tr =
            '<tr>' +
            '<td class="first-header">' + key + '</td>' +
            '<td class="second-header">' + prop + '</td>' +
            '</tr>';
          projectProperties += tr;
        }

        return '<table cellpadding="5" cellspacing="0" border="0" style="padding-left:50px; width: 100%;">'+
            projectProperties +
          '<tr>' +
            '<td class="first-header">'+ this.lang.table_header_IsArchived+':</td>'+
            '<td class="second-header">'+checkbox+'</td>'+
          '</tr>' +


        '</table>';
      },
      buildTable() {

        this.showAll = false;
        const revisions = [];

        if (this.dtFilter) {

          const idx = $.fn.dataTable.ext.search.indexOf(this.dtFilter);

          if (idx > -1) {
            $.fn.dataTable.ext.search.splice(idx, 1);
          }

        }

        this.dtFilter = function (settings, data, dataIndex) {

          if (settings.nTable.id !== 't_' + _vue.id) {

            return true;
          }

          const row = settings.aoData[dataIndex] && settings.aoData[dataIndex]._aData;

          if (!row){

            return true;
          }

          if (_vue.showAll == true) {

            return true;
          }

          return !row.isArchive;
        }



        for (let i = 0, lei = this.dataTable.length; i < lei; i++) {

          const obj = {
            id: this.dataTable[i].id,
            revision: this.dataTable[i].revision,
            status: this.dataTable[i].status,
            date: this.dataTable[i].date,
            login: this.dataTable[i].login,
            isArchive: this.dataTable[i].isArchive,

          }
          for (let j = 0, lej = this.dataTable[i].properties.length; j < lej; j++) {
            obj["p___" + this.dataTable[i].properties[j].name] = this.dataTable[i].properties[j].value != null ? this.dataTable[i].properties[j].value.display : "";
          }

          revisions.push(obj);

        }

        this.$store.dispatch("deselectAllRevisionRow");


        let tableplace = document.getElementById(this.id);
        if (tableplace == null) {
            return;
        }
        while (tableplace.firstChild) {
            tableplace.removeChild(tableplace.firstChild);
        }

        let table = document.createElement("table");
        table.setAttribute("id", "t_" + this.id);
        table.setAttribute("class", "table table-striped table-bordered");
        table.setAttribute("style", "width:100%");
        tableplace.appendChild(table)

        let tr = document.createElement("tr");
        tr.setAttribute("class", "cellHeader");
        let thead = document.createElement("thead");
        thead.appendChild(tr);
        table.appendChild(thead);

        let _vue = this;

        let columns = [
          {
              name: this.lang.table_header_Expand,
              alignInColumn: "left",
              type: "text",
              width: 50
              },
          {
              name: this.lang.table_header_Select,
              alignInColumn: "left",

          },
          {
              name: this.lang.table_header_Revision,
              alignInColumn: "left",

          },
          {
              name: this.lang.table_header_Status,
              alignInColumn: "left",
              dataObject: "1"
          },
          {
              name: this.lang.table_header_Date,
              alignInColumn: "left",

          },
          {
              name: this.lang.table_header_User,
              alignInColumn: "left",

          },


        ]

        let cols = [
          {
              "className": 'details-control',
              "orderable": false,
              "data": null,
              "defaultContent": '<img src="/static/plus.svg">'
          },
          { "data": "id" },
          { "data": "revision" },
          { "data": "status" },
          { "data": "date" },
          { "data": "login" },



        ]

        for (let i = 0, lei = this.dataTable.length; i < lei; i++) {


          for (let j = 0, lej = this.dataTable[i].properties.length; j < lej; j++) {

            const obj = {
              data: "p___" + this.dataTable[i].properties[j].name,

            }

            const objCols = {
              data: "p___" + this.dataTable[i].properties[j].name
            }

            const objColumns = {
              name: "p___" + this.dataTable[i].properties[j].name,
              alignInColumn: "left",
            }

            cols.push(objCols);
            columns.push(objColumns);
          }

        }


          let checkedRev = {
              revisionId: 0,
              revision: 0,
              checked: false,
              login: ""
          };

          for (let j = 0, lej = this.dataTable.length; j < lej; j++) {

              if (this.$route.query.revisionId == this.dataTable[j].id) {
                  checkedRev.revisionId = this.dataTable[j].id;
                  checkedRev.revision = this.dataTable[j].revision;
                  checkedRev.login = this.dataTable[j].login;
              }
          }
          let theHighestRev = {
              revisionId: 0,
              revision: 0,
              checked: false,
              login: ""
          };

          for (let j = 0, lej = this.dataTable.length; j < lej; j++) {

              if (this.dataTable[j].revision > theHighestRev.revision) {
                  theHighestRev.revisionId = this.dataTable[j].id;
                  theHighestRev.revision = this.dataTable[j].revision;
                  theHighestRev.login = this.dataTable[j].login;

              }
          }


          let columnDefs = [

          ];
          let len = columns.length;
          for (let i = 0; i < len; i++) {

              let el = {};

              let classname = '_dt-body-' + columns[i].alignInColumn;

              el = {
                  targets: i,
                  className: classname,

                  render: function (data, type, row, meta) {
                      if (data == null) {
                          data = "";
                      }

                      data = $.fn.dataTable.render.text().display(data);
                      if (data.display != undefined) {
                          data.display = $.fn.dataTable.render.text().display(data.display);
                      }

                      row.login = $.fn.dataTable.render.text().display(row.login);

                      if (meta.col == 1) {


                          let accepted = true;
                          let checked = "";
                          let disabled = "";



                          // }
                          if (checkedRev.revisionId == row.id) {
                              checkedRev.checked = true;
                              checked = "checked";
                              if (_vue.dataTable.length == 1) {
                                  disabled = "disabled";
                              }


                          }



                          let str = "<div class=\"custom-control custom-checkbox \"><input " + checked + " " + disabled + "  type=\"checkbox\" class=\"custom-control checkbox_type btn-primary\" id=\"selected_" + data + "_" + row.revision + "\" data-user=\"" + row.login + "\" value=\"" + accepted + "\"></div>";

                          return str;

                      } else if (meta.col == 2) {



                        return parseFloat(data);
                      } else if (meta.col == 3) {

                        let arch = "";
                        if (row.isArchive == true) {
                          arch = "<b-badge class='badge badge-info'>A</b-badge>";
                        }

                        let variant = Tools.getStatusColor(data.display);
                        if (row.isSubrevision) {
                            //return "";
                        }

                        return "<b-badge class='badge badge-" + variant + " '>" + data.display + "</b-badge>" + arch;
                      } else if (meta.col == 4) {
                          if (data == "") {
                              return data;
                          }
                          return Tools.longDateToShort(data);
                      } else {
                          return data;
                      }




                  }





              }

              columnDefs.push(el);


              let th = document.createElement("th");
              tr.appendChild(th);


              let br = document.createElement("br");
              th.appendChild(br);
              let tx = document.createTextNode(columns[i].name);
              th.appendChild(tx);


          }

          let buttons = [
            {
              text: 'All revisions',
              action: function (e, dt, node) {

                _vue.showAll = !_vue.showAll;
                node.text(_vue.showAll ? 'Unarchived revisions' : 'All revisions');

                dt.draw();

              }
            }
          ]




          let json = {};
          json.paging = false;
          json.info = false;
          json.dom = 'fB<t>';
          json.data = revisions;
          json.myColumnFormats = columns;
          json.select = false;
          json.order = [[2, "desc"]];
          json.columns = cols;
          json.columnDefs = columnDefs;
          json.buttons = buttons;
          json.initComplete = function () {


          }

          //this.$store.dispatch("selectRevisionRow", theHighestRev);
          this.$store.dispatch("selectRevisionRow", checkedRev);

          if ($.fn.dataTable.isDataTable("#t_" + this.id)) {
            this.mainTable.destroy();

          }


          $.fn.dataTable.ext.search.push(this.dtFilter);


          this.mainTable = $('#t_' + this.id).DataTable(json);


          //hide first column in table
          for (let i = 6, lei = columnDefs.length; i < lei; i++){
            this.mainTable.column( i ).visible( false );
          }


          this.mainTable.columns.adjust().draw();

          //search input change view
          let searchplace = document.getElementById("t_" + this.id + "_filter").firstChild

          while (searchplace.firstChild) {

              if (searchplace.firstChild.textContent == "Search:") {
                  searchplace.removeChild(searchplace.firstChild);
                  break;
              }

          }
          searchplace.firstChild.setAttribute("placeholder", this.lang.placeholder_Search);
          searchplace.firstChild.setAttribute("class", "form-control form-control-sm")

          $('#t_'+this.id +' tbody').on('click', 'td.details-control', function (e) {


              let tr = $(this).closest('tr');
              let row = _vue.mainTable.row( tr );

              if ( row.child.isShown() ) {
                  // This row is already open - close it
                  e.target.src = "/static/plus.svg";
                  row.child.hide();
                  tr.removeClass('shown');
              } else {
                  // Open this row
                  e.target.src = "/static/minus.svg";
                  row.child( _vue.format(row.data()) ).show();
                  tr.addClass('shown');
              }
          } );


          $(".checkboxtable").on("click", noclick);


          function noclick(e) {

              e.stopPropagation();

          }
          $("#t_" + this.id + ' tbody').on('click', '.checkbox_type', function (e) {

              let s = e.target.id.split("_");


              let obj = {
                  revisionId: parseInt(s[1]),
                  checked: e.target.checked,
                  revision: parseInt(s[2]),
                  login: this.dataset.user
              }

              if (e.target.checked == true) {
                  _vue.$store.dispatch("selectRevisionRow", obj)
              } else {
                  _vue.$store.dispatch("deselectRevisionRow", obj)
              }
              let arr = [];
              for (let i = 0, le = _vue.$store.getters.selectedRevisionRow.length; i < le; i++) {
                  if (_vue.$store.getters.selectedRevisionRow[i].checked == true) {
                      arr.push(_vue.$store.getters.selectedRevisionRow[i].key);
                  }
              }


          })


          $("#t_" + this.id + ' tbody').on('click', '.checkbox_archive', function (e) {

            let temp = this.id.split("___")

            if (temp[0] == "isArchived") {


                let projectRevisionId = temp[1];

                let obj = {
                    projectRevisionId: projectRevisionId,
                    isArchive: this.checked
                }

                _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_setRevisionAsArchive", obj)
                    .then((result) => {
                        console.log(result)

                        _vue.updateIsArchive(obj)
                })
            }
          })





        },
        selectRevisions() {

            for (let i = 0, le = this.dataTable.length; i < le; i++) {

                if (this.dataTable[i][0].id == this.elementId) {

                    document.getElementById("n_" + this.dataTable[i][0].id).checked = true;
                    this.$store.dispatch("selectRevisionRow", { revisionId: this.dataTable[i][0].id, checked: true })

                }
            }

            let arr = [];
            for (let i = 0, le = this.$store.getters.selectedRevisionRow.length; i < le; i++) {
                if (this.$store.getters.selectedRevisionRow[i].checked == true) {
                    arr.push(this.$store.getters.selectedRevisionRow[i].id);
                }
            }


        }

    },
    destroyed() {

        this.$store.dispatch("deselectAllRevisionRow")
    }


}
</script>
<style lang="scss">
    .ProjectRevisionHistoryComponent {
        table {
            font-size: 0.75rem;
            padding: 0px !important;

        }

        table th {
            padding: 2px !important;

        }

        table th select {
            width: 100% !important;

        }

        table td {
            padding: 0rem !important;

            padding-left: 0.2rem !important;
            padding-right: 0.2rem !important;

        }

        table.dataTable thead th {
            position: relative;
            background-image: none !important;
        }

        .dataTables_processing {
            position: absolute;
            top: 20px;
            left: 50%;
            width: 100%;
            height: 20px;
            margin-left: -50%;
            margin-top: 50px;
            padding-top: 5px;
            text-align: center;
            font-size: 1em;

        }
        .dataTables_filter .form-control-sm, .input-group-sm > .form-control{
          padding: 0.1rem 0.1rem;
          font-size: 0.7rem;
          line-height: 1;
          width: 200px;
        }
        .dataTables_filter {
            font-size: 10px;
            float: left;
            width: 210px;
        }

        .searcher {
            float: left;
        }

        ._dt-body-left {
            text-align: left;
        }

        ._dt-body-right {
            text-align: right;
        }

        ._dt-body-center {
            text-align: center;
        }

        .badge {
            margin-right: 1px;
            margin-top: 2px;
        }
        td.details-control {
        //background: url("/static/plus.svg") no-repeat center center;
        img{
            max-width: 30px;
            padding: 2px;
        }

        }
        tr.shown td.details-control {
        img{
            max-width: 30px;
            padding: 2px;
        }
        //background: url("/static/minus.svg") no-repeat center center;
        }
        .first-header{
            width: 40%;
        }
        .table{
            max-width: 380px;

        }
        .btn {
          padding-top: 1px;
          padding-bottom: 1px;
          padding-left: 3px;
          padding-right: 3px;

          font-size: 0.7rem;
        }
        .btn-group {
          //display: block;
          padding-top: 2px;
          //width: 450px;
          //float: left;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/shared/ProjectRevisionHistoryComponent.vue